import { FC, SVGProps } from 'react'

export const Soundwave: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    {...props}
  >
    <path
      d="M4.66663 4.66669L4.66663 11.3334M1.33325 7.33331L1.33325 8.66665M7.99988 2L7.99988 14M11.3333 4.66669V11.3334M14.6666 7.33331V8.66665"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
